'use client'

import { ChevronLeft } from 'lucide-react'
import { usePathname } from 'next/navigation'

import { AppSidebar } from '~/components/Layout/AppSidebar'
import { AdminSidebar } from '~/components/admin/AdminSidebar'
import { Button } from '~/components/component-library'
import { ComponentLibrarySidebar } from '~/components/component-library/internal/Sidebar'
import { SettingsSidebar } from '~/components/settings/SettingsSidebar'
import { SidebarContainer } from '~/components/sidebar/SidebarContainer'

export { SidebarContainer } from './SidebarContainer'
export { SidebarSection } from './SidebarSection'
export { NotificationDotLabel } from './NotificationDotLabel'

// Shared wrapper for non-app sidebars (settings, admin, component library)
const SecondarySidebarWrapper = ({
  children,
}: {
  children: React.ReactNode
}) => (
  <SidebarContainer className="h-full w-full overflow-y-auto p-2">
    <Button
      prefix={<ChevronLeft className="text-secondary" />}
      variant="tertiary"
      size="small"
      alignLeft
      fullWidth
      href={{ path: '/' }}
    >
      <span className="text-secondary">Back</span>
    </Button>
    <div className="h-2" />
    {children}
  </SidebarContainer>
)

// uses the correct sidebar based on the pathname
export function Sidebar() {
  const pathname = usePathname()

  // component library
  if (pathname.startsWith('/component-library')) {
    return (
      <SecondarySidebarWrapper>
        <ComponentLibrarySidebar />
      </SecondarySidebarWrapper>
    )
  }

  // admin tools
  if (pathname.startsWith('/admin')) {
    return (
      <SecondarySidebarWrapper>
        <AdminSidebar />
      </SecondarySidebarWrapper>
    )
  }

  // settings
  if (pathname.startsWith('/settings')) {
    return (
      <SecondarySidebarWrapper>
        <SettingsSidebar />
      </SecondarySidebarWrapper>
    )
  }

  // all other pages
  return <AppSidebar />
}
